module.exports = __webpack_public_path__ + "img/soldProducts.aa03a997.svg";